import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './sidebar.css'

const STEPS = [
  { checked: true, label: 'Sign Up' },
  { checked: false, label: 'Event Details' },
  { checked: false, label: 'Tickets' },
  { checked: false, label: 'Start Selling' },
]

class Sidebar extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showCta: false,
    }

    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const { showCta } = this.state
    const headerHeight = 630
    if (!showCta && window.scrollY > headerHeight) {
      this.setState({ showCta: true })
    } else if (showCta && window.scrollY <= headerHeight) {
      this.setState({ showCta: false })
    }
  }

  render() {
    const { showCta } = this.state
    const { onGetStarted, onGetInTouch } = this.props

    return (
      <div styleName="sidebar">
        <ul styleName="steps">
          {STEPS.map((step, i) => (
            <li key={i} styleName="step">
              <span styleName={step.checked ? 'radio-checked' : 'radio-unchecked'} />
              <span styleName="label">{step.label}</span>
            </li>
          ))}
        </ul>

        <div styleName={showCta ? 'cta-show' : 'cta-hide'}>
          <button styleName="button-primary" onClick={onGetStarted}>
            Get Started Now
          </button>
          <button styleName="button-secondary" onClick={onGetInTouch}>
            Get In Touch
          </button>
        </div>
      </div>
    )
  }
}

Sidebar.propTypes = {
  onGetStarted: PropTypes.func,
  onGetInTouch: PropTypes.func,
}

export default CSSModules(Sidebar, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/ticketing-page/sidebar/sidebar.js
 **/